import { render, staticRenderFns } from "./BaseListTable.vue?vue&type=template&id=6fbcdba2"
import script from "./BaseListTable.vue?vue&type=script&lang=js"
export * from "./BaseListTable.vue?vue&type=script&lang=js"
import style0 from "./BaseListTable.vue?vue&type=style&index=0&id=6fbcdba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports